export const data = [
  {
    id: 0,
    Name: 'Олимжон',
    Surname: 'Ҳайдаров',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-e422-08dc80bc88b2.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 29 июль',
    Accusation: '139-модда, 140-модда, 165-модда',
    'Prison Term': '8 йил',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': 'article',
  },
  {
    id: 1,
    Name: 'Фозилхўжа',
    Surname: 'Орифхўжаев  ',
    Photo_URL: 'https://gdb.rferl.org/52170000-0aff-0242-affa-08d9bb3b8a6c.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, 28 июнь  ',
    Accusation: '244-модда  ',
    'Prison Term': '7,6 йил',
    'Released time': '2023 йил, декабрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 2,
    Name: 'Эмине-Лемара',
    Surname: 'Мирзааҳмедова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-b88d-08dc80be2ec7.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 1 март',
    Accusation: '139-модда, 140-модда, 165-модда ',
    'Prison Term': '7,6 йил ',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': 'wfwefewf ',
  },
  {
    id: 3,
    Name: 'Абдуқодир',
    Surname: 'Мўминов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-545a-08db935399b3.jpeg',
    Work: '"Кўзгу" канали (Youtube)',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 8 февраль',
    Accusation: ' 165-модда, 168-модда, 141-модда, 189-модда, 211-модда  ',
    'Prison Term': ' 7,3 йил',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 4,
    Name: 'Отабек',
    Surname: 'Аҳлиддинов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-833d-08dc80c12b70.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер, шифокор',
    'Detained time': '2023 йил, куз',
    Accusation: ' 67-модда',
    'Prison Term': '7,1 йил ',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 5,
    Name: 'Хуршид',
    Surname: 'Далиев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-8fdf-08dc80c1bbed.jpg',
    Work: 'Human.uz сайти',
    Ocupation: 'Журналист',
    'Detained time': '2023 йил, 24 январь',
    Accusation: '139-модда, 165-модда, 184-модда, 243-модда ',
    'Prison Term': '7 йил ',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 6,
    Name: 'Сиёвуш',
    Surname: 'Ҳошимов',
    Photo_URL: '',
    Work: '“Ўзбекнефтгаз”',
    Ocupation: 'Матбуот котиби',
    'Detained time': '2023 йил, 24 январь',
    Accusation: '139-модда, 165-модда, 243-модда ',
    'Prison Term': '7 йил',
    'Released time': 'Ҳали қамоқда',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 7,
    Name: 'Ҳаёт',
    Surname: 'Самарқандий  ',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-e560-08dc81647a5b.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, баҳор ',
    Accusation: '165-модда',
    'Prison Term': '7 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 8,
    Name: 'Отабек',
    Surname: 'Сатторий',
    Photo_URL: 'https://gdb.rferl.org/fd0457f4-2e7a-45e0-801e-68d663d5a74d.jpg',
    Work: '“Халқ фикри” канали',
    Ocupation: 'Блогер',
    'Detained time': '2021 йил, 30 январь ',
    Accusation: '139-модда, 165-модда   ',
    'Prison Term': '6,6 йил',
    'Released time': '2024 йил, 5 февраль',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 9,
    Name: 'Саид-Абдулазиз',
    Surname: 'Юсупов',
    Photo_URL: 'https://gdb.rferl.org/EFA5B7AD-6BC3-42E6-89B8-8D6C6F560BF7.jpg',
    Work: 'Жамоат жамғармаси',
    Ocupation: 'Журналист, жамғарма раиси',
    'Detained time': '2019 йил, 10 май ',
    Accusation: '167-модда, 168-модда, 28- модда, 211-модда  ',
    'Prison Term': '6 йил',
    'Released time': '2020 йил, 8 июль',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 10,
    Name: 'Мавжуда',
    Surname: 'Мирзаева ',
    Photo_URL: 'https://gdb.rferl.org/08530000-0a00-0242-11de-08db02dbcd72.jpg',
    Work: 'Бандлик вазирлиги',
    Ocupation: 'Матбуот котиби',
    'Detained time': '2023 йил, 24 январь ',
    Accusation: '113-модда, 165-модда ',
    'Prison Term': '5 йил (озодликни чеклаш)',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 11,
    Name: 'Ситора',
    Surname: 'Бозорова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-c3ec-08dc8536bf1d.png',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2024 йил, апрель  ',
    Accusation: '158-модда ',
    'Prison Term': ' 5 йилу, 2 ой  ',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 12,
    Name: 'Д.',
    Surname: 'Турсунов',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2024 йил, апрель  ',
    Accusation: '158-модда',
    'Prison Term': '5 йил  ',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 13,
    Name: 'Абдуҳаким',
    Surname: 'Абжалилов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-cb69-08dc85382773.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, январь  ',
    Accusation: '165-модда',
    'Prison Term': ' 5 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 14,
    Name: ' Рустам',
    Surname: 'Карим',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-01d6-08dc815315d9.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2019 йил, 8 апрель',
    Accusation: '244-1-модда',
    'Prison Term': '3 йил 1 ой',
    'Released time': '2021 йил,29 июль',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонни тарк этган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 15,
    Name: 'Тўлқин',
    Surname: 'Астанов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-ab06-08dc8153a4c1.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2019 йил, 8 апрель',
    Accusation: '244-1-модда',
    'Prison Term': '5 йил шартли',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 16,
    Name: ' Элёрбек',
    Surname: 'Тожибаев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-f752-08dc8f973a94.jpg',
    Work: 'Taftish.uz сайти',
    Ocupation: 'Журналист',
    'Detained time': '2021 йил, куз ',
    Accusation: '219-модда, 236-модда ',
    'Prison Term': ' 3 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 17,
    Name: 'Собиржон',
    Surname: 'Бобониёзов  ',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-741b-08dc8157114a.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, январь',
    Accusation: '158-модда ',
    'Prison Term': '3 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 18,
    Name: 'Акбар',
    Surname: 'Нуримбетов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-87b9-08dc8f98d7fc.jpg',
    Work: 'Effect.uz сайти  ',
    Ocupation: ' Журналист',
    'Detained time': '2021 йил, ноябрь  ',
    Accusation: '219-модда, 236-модда  ',
    'Prison Term': '3 йил',
    'Released time': 'Озодликни чеклаш',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 19,
    Name: 'Миразиз',
    Surname: 'Бозоров ',
    Photo_URL: 'https://gdb.rferl.org/23303470-f17a-4200-aa31-67ef35471733.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер ',
    'Detained time': '2022 йил, январь',
    Accusation: '139-модда ',
    'Prison Term': '3 йил ',
    'Released time': 'Озодликни чеклаш',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 20,
    Name: 'Ҳамиджон',
    Surname: ' Аҳмедов ',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-9da0-08dc8f99587b.jpg',
    Work: 'Effect.uz сайти',
    Ocupation: ' Журналист ',
    'Detained time': '2021 йил, ноябрь  ',
    Accusation: '219-модда, 236-модда ',
    'Prison Term': '2,6 йил ',
    'Released time': 'Озодликни чеклаш',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 21,
    Name: 'Ҳумоюн',
    Surname: ' Умрзоқов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-8099-08dc89825a9a.jpg',
    Work: 'Ижтимоий тармоқлар  ',
    Ocupation: 'Блогер ',
    'Detained time': '2021 йил, сентябрь',
    Accusation: '139 - модда',
    'Prison Term': '1 йил',
    'Released time': '2022 йил, 17 апрель',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 22,
    Name: 'Валижон',
    Surname: 'Калонов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0a00-0242-166f-08dc112ea75d.jpg',
    Work: 'Ижтимоий тармоқлар ',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': ' 2021 йил, декабрь ',
    Accusation: '158-модда  ',
    'Prison Term': 'Номаълум ',
    'Released time': 'Психиатрия шифохонасида',
    Persecution: '',
    Pressure: '',
    Judgement: 'Руҳий шифохона',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 23,
    Name: 'Шоҳида',
    Surname: ' Саломова',
    Photo_URL: 'https://gdb.rferl.org/02490000-0aff-0242-7b8c-08dae34e2e3c.png',
    Work: '“Патанатомия страни Уз” канали   ',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, декабрь',
    Accusation: '139-модда, 140-модда ',
    'Prison Term': 'Номаълум',
    'Released time': 'Психиатрия шифохонасида',
    Persecution: '',
    Pressure: '',
    Judgement: 'Руҳий шифохона',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 24,
    Name: 'Шабнам',
    Surname: 'Оллашукурова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-712c-08dc854612ab.jpg',
    Work: 'Ижтимоий тармоқлар ',
    Ocupation: ' Блогер ',
    'Detained time': '2019 йил, 23 сентябрь',
    Accusation: '183-модда, 192-модда, 202-модда',
    'Prison Term': 'Психиатрия шифохонаси',
    'Released time': '2019 йил, 28 декабрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Руҳий шифохона',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 25,
    Name: 'Ўткирбек',
    Surname: 'Чоршанбиев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-10e8-08dc8549dfee.jpg',
    Work: 'Youtube',
    Ocupation: ' Блогер',
    'Detained time': '2022 йил,  10 март',
    Accusation: '168-модда',
    'Prison Term': '5 йил',
    'Released time': '2023 йил, 15 ноябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 26,
    Name: 'Даулетмурат',
    Surname: 'Тажимуратов',
    Photo_URL: 'https://gdb.rferl.org/069c0000-0aff-0242-2f93-08db035b4045.jpg',
    Work: '«Эл хизметинде» газетаси',
    Ocupation: 'Журналист',
    'Detained time': '2022 йил, 1 июль',
    Accusation: '159-модда, 167-модда, 243-модда, 244-модда',
    'Prison Term': '16 йил',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 27,
    Name: 'Лолагул',
    Surname: 'Қаллиханова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-c624-08dc8555d6b5.jpg',
    Work: 'Makan.uz',
    Ocupation: 'Журналист',
    'Detained time': '2022 йил, июль',
    Accusation: '159-модда, 244-модда',
    'Prison Term': '8 йил',
    'Released time': 'Шартли озод қилинган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 28,
    Name: 'Бахтияр',
    Surname: 'Кадирбергенов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-3dcb-08dc855675c7.jpg',
    Work: 'Ayama.uz',
    Ocupation: 'Журналист',
    'Detained time': '2022 йил, июль',
    Accusation: '244-модда,  277-модда',
    'Prison Term': '5 йил',
    'Released time': 'Шартли озод қилинган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 29,
    Name: 'Абдималик',
    Surname: 'Хожаназаров',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-2c66-08dc8560755d.jpg',
    Work: '«Эл хизметинде» газетаси',
    Ocupation: ' Журналист',
    'Detained time': '2022 йил, июль',
    Accusation: '244-модда',
    'Prison Term': ' 5 йил',
    'Released time': 'Шартли озод қилинган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 30,
    Name: 'Есимкан',
    Surname: 'Канаатов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-54f9-08dc8f99d1a4.jpg',
    Work: '«Ишонч» газетаси, ЎзА',
    Ocupation: 'Журналист',
    'Detained time': '2022 йил, июль',
    Accusation: '244-модда',
    'Prison Term': ' 5 йил',
    'Released time': 'Шартли озод қилинган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 31,
    Name: 'Азамат',
    Surname: 'Нуратдинов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-20c1-08dc8f9b4ea6.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, июль',
    Accusation: '244-модда',
    'Prison Term': '5 йил',
    'Released time': 'Шартли озод қилинган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 32,
    Name: 'Ўткирбек',
    Surname: 'Собиров',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2022 йил, январь',
    Accusation: '158-модда',
    'Prison Term': '2,3 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 33,
    Name: 'Давлат',
    Surname: 'Назар  ',
    Photo_URL: 'https://gdb.rferl.org/B2616C29-491B-4F76-85FE-214EDB0E8921.jpg',
    Work: ' "Хоразм ёшлари" газетаси',
    Ocupation: 'Журналист',
    'Detained time': '2018 йил, 29 октябрь',
    Accusation: '183-модда',
    'Prison Term': ' 7 сутка',
    'Released time': 'Ҳалок бўлган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 34,
    Name: 'Бобомурод',
    Surname: 'Абдулла ',
    Photo_URL: 'https://gdb.rferl.org/FFB4A515-0262-47CD-BCBB-CB6BBCEC5317.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Мустақил журналист',
    'Detained time': ' 2017 йил, 27 сентябрь',
    Accusation: '159- модда',
    'Prison Term': ' 3 йилга ахлоқ тузатиш',
    'Released time': '2018 йил, 7 май',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонни тарк этган',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 35,
    Name: ' Маҳмуд',
    Surname: 'Ражаб  ',
    Photo_URL: 'https://gdb.rferl.org/73AD6673-4F4E-438D-9D9B-FAAADC7FCDF7.jpg',
    Work: ' Ижтимоий тармоқлар',
    Ocupation: 'Мустақил журналист',
    'Detained time': '2019 йил, 23 сентябрь',
    Accusation: '183-модда, 192-модда, 202-модда',
    'Prison Term': ' 10 сутка',
    'Released time': '2019 йил, 3 октябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 36,
    Name: 'Маҳдий',
    Surname: ' Мирзаев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-d816-08db66801374.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 20 май',
    Accusation: '155-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 37,
    Name: 'Дилшод',
    Surname: 'Искандаров',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2023 йил, август',
    Accusation: '158-модда',
    'Prison Term': '2,5 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 38,
    Name: 'Гули',
    Surname: 'Мирзаева',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-aa52-08dc89877e0f.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, 24 февраль',
    Accusation: '158-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 39,
    Name: 'Комил',
    Surname: 'Аҳмедов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-6d76-08dc898826b8.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: ' Блогер',
    'Detained time': '2022 йил, 22 июль',
    Accusation: '184-модда',
    'Prison Term': '15 сутка',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 40,
    Name: 'Элмурод',
    Surname: ' Одил',
    Photo_URL: 'https://gdb.rferl.org/069c0000-0aff-0242-bc76-08dafa32aca6.png',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил,  26 май',
    Accusation: '183-модда, 198-модда',
    'Prison Term': '15 сутка',
    'Released time': '2023 йил, 11 июнь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: 'Фаолиятини тўхтатган',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 41,
    Name: 'Отабек',
    Surname: 'Нуритдинов',
    Photo_URL: 'https://gdb.rferl.org/3BB178E0-CC08-469C-A11F-79C6ABA53C49.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2019 йил, 30 декабрь',
    Accusation: '140-модда, 183-модда',
    'Prison Term': '15 сутка',
    'Released time': '2020 йил, 14 январь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 42,
    Name: 'Ҳожиакбар',
    Surname: 'Носиров',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-54a4-08db39814da9.jpg',
    Work: 'Аctivist лойиҳаси',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 8 апрель',
    Accusation: '84−3-модда, 194-модда',
    'Prison Term': '15 сутка',
    'Released time': '2023 йил, 22 апрель',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 43,
    Name: 'Бобур',
    Surname: 'Ганиев',
    Photo_URL: 'https://gdb.rferl.org/ffd2289f-ebfd-402c-b492-0cb0ac05d710.jpg',
    Work: 'Taftish.uz',
    Ocupation: 'Журналист',
    'Detained time': '2021 йил, 1 октябрь',
    Accusation: '41-модда, 194-модда, 195-модда',
    'Prison Term': '15 сутка',
    'Released time': '2021 йил, 16 октябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 44,
    Name: 'Аброр',
    Surname: 'Козубаев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-0fbb-08dc898d4e6e.jpg',
    Work: 'Taftish.uz',
    Ocupation: 'Журналист',
    'Detained time': '2021 йил, 1 октябрь',
    Accusation: ' 194-модда, 195-модда',
    'Prison Term': '15 сутка',
    'Released time': '2021 йил, 16 октябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 45,
    Name: 'Бунёджон',
    Surname: 'Бозоров',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': ' 2023 йил, октябрь',
    Accusation: '158- модда, 159-модда',
    'Prison Term': '5,1 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 46,
    Name: 'Cобир',
    Surname: 'Нормаматов',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2024 йил, апрель',
    Accusation: '158-модда',
    'Prison Term': '2,6 йил',
    'Released time': 'Мажбурий меҳнат',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 47,
    Name: 'Номаълум блогер',
    Surname: '',
    Photo_URL: '',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2022 йил, февраль',
    Accusation: ' 158-модда',
    'Prison Term': '4,6 йил',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 48,
    Name: 'Озодбек',
    Surname: 'Қурбонов',
    Photo_URL: 'https://gdb.rferl.org/d2f348a0-b2e4-4906-874f-9db1d3d5e8b2.png',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2021 йил, 15 июль',
    Accusation: '183-модда',
    'Prison Term': '15 сутка',
    'Released time': '2021 йил, 31 июль',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 49,
    Name: 'Аброр',
    Surname: ' Мухтор Алий',
    Photo_URL: 'https://gdb.rferl.org/CD2700AE-AACF-4312-BF87-C97691B19738.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Диний блогер',
    'Detained time': '2024 йил, 6 февраль',
    Accusation: '194-модда, 195-модда',
    'Prison Term': '15 сутка',
    'Released time': '2024 йил, 21 февраль',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 50,
    Name: 'Сундар',
    Surname: 'Қорабоев',
    Photo_URL: 'https://gdb.rferl.org/56ab58d8-3e7d-406a-8e31-1fdca6e36089.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2021 йил, 16 март',
    Accusation: '183-модда',
    'Prison Term': '10 сутка',
    'Released time': '021 йил, 27 март',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 51,
    Name: 'Дадахон',
    Surname: 'Ҳайдаров',
    Photo_URL: 'https://gdb.rferl.org/d50b0bc8-8e6a-4a79-b5c5-cbaf26d46b50_w1023_r1_s.png',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2020 йил, 22 август',
    Accusation: 'Гумондор',
    'Prison Term': '10 сутка',
    'Released time': '2020 йил, 2 сентябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 52,
    Name: 'Sardor gangster',
    Surname: '',
    Photo_URL: 'https://gdb.rferl.org/01000000-0a00-0242-7304-08dc369d2761_w1023_r1_s.jpg',
    Work: 'TikTok ва YouTube',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил 21 февраль',
    Accusation: '183-модда, 184−3-модда',
    'Prison Term': '10 сутка',
    'Released time': '2024 йил 2 март',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 53,
    Name: 'Умид',
    Surname: ' Каримов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-7d68-08dc8a0ce0b1.jpg',
    Work: 'NasafNews',
    Ocupation: 'Журналист',
    'Detained time': '2023 йил, 29 май',
    Accusation: '183-модда',
    'Prison Term': ' 5 сутка',
    'Released time': ' 2023 йил, 3 июнь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 54,
    Name: 'Мақсуд',
    Surname: 'Музаффаров',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-2f29-08dc8a0e0eed.jpg',
    Work: 'AvtoblogUz  ',
    Ocupation: ' Блогер',
    'Detained time': '2023 йил, 29 май',
    Accusation: '125-модда, 126-модда, 183-модда',
    'Prison Term': '5 сутка',
    'Released time': '2023 йил, 3 июнь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 55,
    Name: 'Мусанниф',
    Surname: 'Адҳам',
    Photo_URL:
      'https://gdb.rferl.org/07bd0000-0aff-0242-1bc9-08da3a3d8f3e_cx0_cy9_cw99_w1023_r1_s.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Диний блогер',
    'Detained time': '2018 йил, 28 август',
    Accusation: '194-модда, 195-модда',
    'Prison Term': '15 сутка',
    'Released time': '2018 йил, 11 сентябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 56,
    Name: 'Севинч',
    Surname: 'Саъдуллаева',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-dcb7-08dc8a1059c7.jpeg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2022 йил, 11 ноябрь',
    Accusation: ' 183-модда',
    'Prison Term': ' 5 сутка',
    'Released time': '4 суткада чиқди',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 57,
    Name: 'Усмонжон',
    Surname: 'Қодиров',
    Photo_URL:
      'https://gdb.rferl.org/BAACF960-736F-44E6-86D4-66AFB10566B4_cx0_cy1_cw0_w1023_r1_s.jpg',
    Work: 'Фарғона вилоят телевидение',
    Ocupation: 'Журналист',
    'Detained time': '2020 йил, 27 май',
    Accusation: '54-модда, 183-модда, 194-модда',
    'Prison Term': '15 сутка',
    'Released time': ' 2 суткада чиқди',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 58,
    Name: 'Жўрабек',
    Surname: 'Қимизов',
    Photo_URL: 'https://gdb.rferl.org/F2813B88-A23D-457A-9364-F3B5D40D145A_w1023_r1_s.jpg',
    Work: 'YouTube',
    Ocupation: 'Блогер',
    'Detained time': '2020 йил, 26 февраль',
    Accusation: '168-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 59,
    Name: 'Наргиза',
    Surname: 'Келдиёрова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-1cf2-08dc8a139177.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, 28 февраль',
    Accusation: '158-модда, 165-модда, 155-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Президентни ҳақорат',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 60,
    Name: 'Шукрулла',
    Surname: 'Парпиев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-521e-08dc8a19d803.jpg',
    Work: '“Ҳимоячи блогерлар” МЧЖ',
    Ocupation: ' МЧЖ раҳбари, блогер',
    'Detained time': ' 2024 йил, 28 февраль',
    Accusation: '165-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 61,
    Name: 'Дилдора',
    Surname: ' Ҳакимова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-8745-08dc8a16d3d9.jpg',
    Work: '“Инсон ҳуқуқи ва қадри” канали',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, 28 февраль',
    Accusation: '165-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Қамоқ',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 62,
    Name: 'Зиёвуддин',
    Surname: 'Раҳим',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-5639-08dc8ac19c9d.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Диний блогер',
    'Detained time': '2018 йил,  28 август',
    Accusation: '194-модда, 195-модда',
    'Prison Term': '10 сутка',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 63,
    Name: 'Отабек',
    Surname: 'Усмонов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-620f-08dc8ac3be55.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2018 йил,  30 август',
    Accusation: ' Номаълум',
    'Prison Term': '15 сутка',
    'Released time': '2018 йил, 11 сентябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 64,
    Name: 'Хуршидбек',
    Surname: 'Муҳаммадрозиқов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-2c6a-08dc8ac4fdf8.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2018 йил,  3 сентябрь',
    Accusation: 'Номаълум',
    'Prison Term': '15 сутка',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 65,
    Name: 'Миразиз',
    Surname: 'Аҳмедов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-17d3-08dc8acb7588.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2018 йил, 2 сентябрь',
    Accusation: '  Номаълум',
    'Prison Term': '15 сутка',
    'Released time': '  Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонни тарк этган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 66,
    Name: 'Дилшодбек',
    Surname: 'Халилов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-b74a-08dc8ad2bba4.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2018 йил, 2 сентябрь',
    Accusation: '  Номаълум',
    'Prison Term': '10 сутка',
    'Released time': '2018 йил, 11 сентябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 67,
    Name: 'Тўрабек',
    Surname: 'Боймирзаев',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-1139-08dc8ad22160.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2018 йил, 27 август',
    Accusation: '  Номаълум',
    'Prison Term': ' 15 сутка',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 68,
    Name: 'Аббос',
    Surname: 'Насриддинов',
    Photo_URL: 'https://gdb.rferl.org/8015BB89-120A-4086-9F2E-50DC771D4F52_w1023_r1_s.jpg',
    Work: 'Facebook',
    Ocupation: 'Тармоқ фаоли',
    'Detained time': '2018 йил, февраль',
    Accusation: '40- модда,  41- модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 69,
    Name: 'Ҳаёт Хон',
    Surname: 'Насриддинов',
    Photo_URL: 'https://gdb.rferl.org/545298E4-0B55-4E47-8BC7-3F97A654BAB7_w1023_r1_s.jpg',
    Work: 'Фарғона.ру',
    Ocupation: ' Журналист, блогер',
    'Detained time': '2017 йил, 20 октябрь',
    Accusation: '159-модда',
    'Prison Term': 'Оқланди',
    'Released time': '2018 йил, 7 май',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 70,
    Name: 'Камолиддин',
    Surname: 'Ҳалимжонов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-4a9d-08dc8ad5bfc1.jpg',
    Work: 'Аччиқ ТВ канали',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, 2 май',
    Accusation: '165-модда',
    'Prison Term': 'Номаълум',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Товламачилик',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 71,
    Name: 'Фазилат ',
    Surname: 'Салимова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0a00-0242-c0d7-08dc91d53851.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2024 йил, 19 июнь',
    Accusation: '195-модда, 202-модда',
    'Prison Term': '8 сутка',
    'Released time': 'Номаълум',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 72,
    Name: ' Анастасия',
    Surname: 'Павленко',
    Photo_URL: 'https://gdb.rferl.org/8c8e0000-0aff-0242-530d-08d9dc131b99_w1023_r1_s.png',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Журналист',
    'Detained time': '2022 йил, 18 январь',
    Accusation: '45-модда, 46-модда, 202-модда',
    'Prison Term': 'Жарима',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: 'Жарима',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 73,
    Name: 'Шавкат',
    Surname: 'Ҳасан',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-539e-08dc8ad8b6b4.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Диний блогер',
    'Detained time': '2023 йил, 23 май',
    Accusation: '184-2-модда',
    'Prison Term': 'Жарима',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: 'Жарима',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 74,
    Name: 'Саъдуллох',
    Surname: 'Абдул-Карим',
    Photo_URL: '',
    Work: 'Facebook',
    Ocupation: 'Диний блогер',
    'Detained time': '2018 йил, 31 август',
    Accusation: '41-модда',
    'Prison Term': 'Жарима',
    'Released time': '2018 йил, 6 сентябрь',
    Persecution: '',
    Pressure: '',
    Judgement: 'Жарима',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 75,
    Name: 'Олимжон',
    Surname: 'Тўхтаназаров',
    Photo_URL:
      'https://gdb.rferl.org/03C4CE14-B3A7-44AC-991A-331B7C94D840_cx0_cy27_cw0_w1023_r1_s.jpg',
    Work: 'ЎзМТРК',
    Ocupation: 'Режиссёр',
    'Detained time': '2018 йил,  22 сентябрь',
    Accusation: '168-модда,  211- модда',
    'Prison Term': '2 йил, 8 ой',
    'Released time': 'озодликдан чеклаш',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 76,
    Name: 'Михаил',
    Surname: ' Довлатов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-011e-08dc8ae4ec13.jpg',
    Work: 'Nuz.uz',
    Ocupation: 'Журналист',
    'Detained time': '2024 йил, 14 январь',
    Accusation: '183-модда, 194-модда',
    'Prison Term': 'Жарима',
    'Released time': 'Иш тугатилган',
    Persecution: '',
    Pressure: '',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 77,
    Name: 'Санжар',
    Surname: 'Хўжа',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-e3a6-08dc8ae979ac.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': 'Қидирувда',
    Accusation: '168-модда',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Қидирувда',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонни тарк этган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 78,
    Name: 'Шерали',
    Surname: 'Комилов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-b346-08dc8b10ab1d.jpg',
    Work: 'Detektiv Uz',
    Ocupation: 'Блогер',
    'Detained time': 'Қидирувда',
    Accusation: '168-модда,  140-модда',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: '',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Қидирувда',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 79,
    Name: 'Шоҳида',
    Surname: 'Ёқуб',
    Photo_URL:
      'https://gdb.rferl.org/10040000-0aff-0242-6e0d-08da5db75430_cx0_cy8_cw0_w1023_r1_s.png',
    Work: 'Халқаро матбуот',
    Ocupation: 'Мустақил журналист',
    'Detained time': '2023 йил, 3 апрель',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 80,
    Name: ' Ҳамид',
    Surname: 'Исмоил',
    Photo_URL:
      'https://gdb.rferl.org/4610CBD6-8FA5-4C89-A71C-D114B3045786_cx0_cy5_cw0_w1023_r1_s.jpg',
    Work: 'ВВС',
    Ocupation: 'Журналист',
    'Detained time': '2017 йил, март',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 81,
    Name: 'Искандар',
    Surname: 'Македонский ',
    Photo_URL: 'https://gdb.rferl.org/4628A68F-6B96-4534-B135-49D97F3D27C8_w1023_r1_s.jpg',
    Work: 'Youtube',
    Ocupation: 'Блогер',
    'Detained time': '2021 йил, 10 июнь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 82,
    Name: 'Баҳром',
    Surname: 'Раҳмон',
    Photo_URL: 'https://gdb.rferl.org/8181692C-039F-4DD3-AAFB-00433CB8A64A_w1023_r1_s.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': ' 2020 йил, 24 январь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 83,
    Name: 'Умид',
    Surname: 'Бобоматов',
    Photo_URL: 'https://gdb.rferl.org/3E90267A-592B-4D4F-8F67-9282E9EE5B70.jpg',
    Work: 'Озодлик',
    Ocupation: 'Журналист',
    'Detained time': '2023 йил, 5 февраль',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 84,
    Name: ' Агнешка',
    Surname: 'Пикулицка',
    Photo_URL: 'https://gdb.rferl.org/30CEF63E-FE10-41AF-A62B-720191284B1C_w1023_r1_s.jpg',
    Work: 'Ҳалқаро матбуот',
    Ocupation: 'Мустақил журналист',
    'Detained time': '2021 йил, 7 ноябрь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонга киритилмаган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонга киритилмаган',
    'International reaction': true,
    'Additional text': '',
  },
  {
    id: 85,
    Name: 'Екатерина',
    Surname: 'Сажнева',
    Photo_URL: 'https://gdb.rferl.org/4627F390-D809-4346-B422-08C83F8BAA88_w1023_r1_s.jpg',
    Work: ' “Московский комсомолец”',
    Ocupation: 'Журналист',
    'Detained time': ' 2016 йил, 29 ноябрь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистондан ҳайдалган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистондан ҳайдалган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 86,
    Name: 'Эдда',
    Surname: 'Шлагер',
    Photo_URL:
      'https://gdb.rferl.org/3E9FD0C1-5C01-4BE9-AEB5-724338A1B8D6_cx0_cy13_cw0_w1023_r1_s.jpg',
    Work: 'Германия жамоатчилик радиоси',
    Ocupation: 'Журналист',
    'Detained time': '2016 йил, 10 ноябрь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистондан ҳайдалган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: '',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистондан ҳайдалган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 87,
    Name: 'Алексей',
    Surname: 'Гаршин',
    Photo_URL: 'https://gdb.rferl.org/a608a6f2-9e34-43a3-b77d-4518a702cb9f_mw1600_q70_s.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Ўзбекистонни тарк этган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': 'Ўзбекистонни тарк этган',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 88,
    Name: 'Бобур',
    Surname: ' Фозилхон',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-623b-08dc8b16e103.jpg',
    Work: '“Sport” телеканали',
    Ocupation: 'Журналист',
    'Detained time': '2020 йил, 22 май',
    Accusation: 'Радиодаги танқид',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Ишдан ҳайдалган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 89,
    Name: 'Жамолиддин',
    Surname: 'Бобожонов ',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-a2e8-08dc8b1809ac.jpg',
    Work: '“Sport” телеканали',
    Ocupation: 'Журналист',
    'Detained time': '2020 йил, 22 май',
    Accusation: 'Радиодаги танқид',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Ишдан ҳайдалган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 90,
    Name: ' Ибрат',
    Surname: 'Сафо ',
    Photo_URL:
      'https://gdb.rferl.org/01000000-0a00-0242-c847-08dc392529c5_cx0_cy4_cw0_w1023_r1_s.jpg',
    Work: 'BBC',
    Ocupation: 'Журналист',
    'Detained time': '2024 йил, 28 февраль',
    Accusation: 'Facebookдаги пост',
    'Prison Term': '',
    'Released time': '',
    Persecution: 'Органга чақирилган',
    Pressure: '',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Органга чақирув',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 91,
    Name: ' Фарҳод Темиртирноқ',
    Surname: '',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-44c5-08db82ac4d36.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2023 йил, 6 июль',
    Accusation: 'Партия тузиш ҳаракати',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Россиядан депорт қилинган',
    Judgement: 'Ҳибс',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 92,
    Name: 'Фотима',
    Surname: 'Жўраева',
    Photo_URL: 'https://gdb.rferl.org/00ef0000-0a00-0242-dd52-08d9ae741301_w1023_r1_s.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2021 йил, 22 ноябрь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Калтакланган',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 93,
    Name: 'Дима',
    Surname: ' Қаюм',
    Photo_URL: 'https://gdb.rferl.org/07520000-0aff-0242-a562-08da38e9837f_w1023_r1_s.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2020 йил, 26 октябрь',
    Accusation: 'Танқидий постлар',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Босимга учраган',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 94,
    Name: 'Отабек',
    Surname: 'Жўраев ',
    Photo_URL: 'https://gdb.rferl.org/8EE5BF00-39AB-4DC5-8E20-29B3C4919D34.jpg',
    Work: 'Ижтимоий тармоқлар',
    Ocupation: 'Блогер',
    'Detained time': '2019 йил, 5 август',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Калтакланган',
    Judgement: '',
    Accusation_B: 'Бошқа айбловлар',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 95,
    Name: ' Бахтиёр',
    Surname: 'Эсонов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-c08e-08dc8f9392bf.jpg',
    Work: '“Ўзбекистон қишлоқ хўжалиги” журнали',
    Ocupation: 'Журналист',
    'Detained time': '2020 йил, 21 ноябрь ',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Калтакланган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 96,
    Name: 'Феруза',
    Surname: 'Нажмиддинова',
    Photo_URL: 'https://gdb.rferl.org/01000000-0aff-0242-7310-08dc8f942f73.jpg',
    Work: 'Qalampir.uz',
    Ocupation: 'Журналист',
    'Detained time': '2021 йил, 7 август',
    Accusation: 'Танқидий мақолалар',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Таҳқирловчи видео тарқалган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 97,
    Name: 'Ғиёсбек',
    Surname: 'Эшов',
    Photo_URL: 'https://gdb.rferl.org/827B7190-E58E-4404-88DA-8885EC4A67F1.jpg',
    Work: ' Effect.uz',
    Ocupation: 'Тасвирчи',
    'Detained time': '2020 йил, 13 май',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Калтакланган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 98,
    Name: 'Алишер',
    Surname: 'Рўзиохунов',
    Photo_URL: 'https://gdb.rferl.org/01000000-0a00-0242-8423-08dc8f9563b9.jpg',
    Work: 'Kun.uz ',
    Ocupation: 'Журналист',
    'Detained time': '2020 йил, 23 октябрь',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Калтакланган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Ҳужумга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
  {
    id: 99,
    Name: 'Болтабой',
    Surname: ' Матқурбонов',
    Photo_URL:
      'https://gdb.rferl.org/3B1709DE-EFE2-4706-959C-79FDFA6FBEAA_cx0_cy21_cw0_w1023_r1_s.jpg',
    Work: '"Муштум" журнали',
    Ocupation: 'Журналист',
    'Detained time': '2019 йил, 21 июль',
    Accusation: '',
    'Prison Term': '',
    'Released time': '',
    Persecution: '',
    Pressure: 'Босимга учраган',
    Judgement: '',
    Accusation_B: '',
    Persecution_B: 'Босимга учраган',
    Prohibition: '',
    'Exile/Ban': '',
    'International reaction': '',
    'Additional text': '',
  },
];
